/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { env } from '../env/index.js';
import register from './register/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var globalConfig = {
    isPanguMiniApp: false,
};
/**
 * 全局配置。
 * @deprecated 这个API可能将来去除，目前仅服务于盘古业务，用于区分标志。
 * @example 使用案例：
 * import { configuration } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * configuration({ isPanguMiniApp: env.isMiniwebDingTalk })
 * @author 敬文
 */
var configuration = function (config) {
    return Object.assign(globalConfig, config);
};
/**
 * 扩展设计：https://yuque.antfin.com/cn-xt/arch/vaa0vx#E1g4c
 * T 是统一的输入参数，R是内部统一的输出参数， K是用户自定义的输出参数
 * @example 使用案例：
 * import { extend } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * // 定义跨端扩展函数
 * const loginBuc = extend<{name: string}>({
 *  web: {
 *      // 菜鸟App环境时，执行该方法
 *      cn: (options, context) => {},
 *
 *      // 淘宝App环境时，执行该方法
 *      tb: (options, context) => {},
 *  }
 * });
 *
 * // 使用跨端函数
 * loginBuc({ name: 'xxx' })
 *  .then(res => console.log(res))
 *  .catch(err => console.error(err));
 * @author 敬文
 */
var extend = function (
/** 扩展部分 */
apiConfig, 
/** 基础函数【可选】，一般是cn-uni-api里的API */
extendUniAPI, 
/** 判端环境【可选】，apiConfig参数执行依据 */
extendEnv) {
    // 基础判端
    var clientEnv = __assign(__assign(__assign({}, env), { 
        /**
         * 老盘古。这里作为1个端去处理，业务上可能在2023年下半年（无定论）不再维护。
         * 满足条件（同时）1. 一定在钉钉小程序webview中（自动） 2. 用户手动设置isPanguMiniApp=true
         */
        isPanguMiniApp: env.isMiniwebDingTalk && (function () { return globalConfig.isPanguMiniApp === true; }) }), extendEnv);
    // 使用函数体，延迟执行判端
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // @ts-ignore TODO 没想到好的解法处理TS类型，暂时先忽略
        return register(apiConfig, extendUniAPI, clientEnv).apply(void 0, args);
    };
};

export { configuration, extend };
